import { render, staticRenderFns } from "./MarketTrends.vue?vue&type=template&id=11ba6d67&"
import script from "./MarketTrends.vue?vue&type=script&lang=js&"
export * from "./MarketTrends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports